import React from 'react';
import PropTypes from 'prop-types';
import TreeRow from './TreeRow';
import { map } from 'lodash';
import { IconPowertrainGroup } from 'svgIcons/MotionPortalIcons';
import AssetNode from './AssetNode';
import { useNodeExpansion } from './HierarchyExpansionContext';

const PowertrainNode = ({
    powertrain,
    depth,
    selectedAsset,
    onSelectAsset,
    leftPanelSize,
    allAssets,
    selectionNodeIds,
    selectedAssetSignalCounts
}) => {
    const { expanded, toggle } = useNodeExpansion(`powertrain-${powertrain?.powertrainId}`);
    const hasSelectionDot = !!selectionNodeIds?.has(`powertrain-${powertrain?.powertrainId}`);

    return (
        <>
            <TreeRow
                depth={depth}
                icon={<IconPowertrainGroup />}
                label={powertrain.name}
                count={powertrain.assets?.length}
                condition={powertrain.condition}
                isExpanded={expanded}
                onToggle={toggle}
                hasSelectionDot={hasSelectionDot}
            />
            {expanded && map(powertrain.assets, (asset, index) =>
                <AssetNode
                    key={asset?.assetId}
                    depth={depth}
                    index={index}
                    selectedAsset={selectedAsset}
                    asset={asset}
                    allAssets={allAssets}
                    onSelectAsset={onSelectAsset}
                    leftPanelSize={leftPanelSize}
                    selectionNodeIds={selectionNodeIds}
                    selectedAssetSignalCounts={selectedAssetSignalCounts}
                />
            )}
        </>
    );
};

PowertrainNode.propTypes = {
    powertrain: PropTypes.object.isRequired,
    depth: PropTypes.number.isRequired,
    selectedAsset: PropTypes.object,
    onSelectAsset: PropTypes.func,
    leftPanelSize: PropTypes.number,
    showThreshold: PropTypes.bool,
    showTrend: PropTypes.bool,
    allAssets: PropTypes.array,
    selectionNodeIds: PropTypes.instanceOf(Set),
    selectedAssetSignalCounts: PropTypes.object
};

export default PowertrainNode;
